import { useEffect, useId, useRef } from "react";
import { Button } from "./components";

export function GenerationConflictDialog({
  profileName,
  onClose,
  onReplace,
}: {
  profileName: string;
  onClose: () => void;
  onReplace: () => void;
}) {
  const dialog = useRef<HTMLDialogElement>(null);
  const title = useId();
  useEffect(() => {
    const element = dialog.current!;
    element.showModal();
    return () => element.close();
  }, []);
  return (
    <dialog
      ref={dialog}
      className="impersonation-picker"
      aria-labelledby={title}
      onCancel={(event) => {
        event.preventDefault();
        onClose();
      }}
    >
      <header>
        <h2 id={title}>Generation already queued</h2>
      </header>
      <p>
        A generation for <strong>{profileName}</strong> with the same data is
        already queued or running.
      </p>
      <p>Cancel that generation and start a new one?</p>
      <footer>
        <button type="button" className="button" autoFocus onClick={onClose}>
          Keep existing generation
        </button>
        <Button kind="primary" onClick={onReplace}>
          Cancel existing and start new
        </Button>
      </footer>
    </dialog>
  );
}
